exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".expand-icon-container{cursor:pointer;align-content:center;line-height:0}.expand-icon-container .expand-icon{width:1.25rem;height:1.25rem;transition:200ms}.expand-icon-container .expand-icon.expanded{transform:rotate(-180deg)}", ""]);

// exports
